import React, { useState, useEffect } from "react";
import { Typography, Grid, Container, TextField } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import CustomButton from "../../components/Custom/CustomButton";
import { CustomLabel } from "../../components/Custom/CustomTypography";
import { CustomValue } from "../../components/Custom/CustomTypography";

export default function FarmerCommodity() {
  const [, setData] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  const details = [
    { label: "Farmer Name", value: "John Doe" },
    { label: "Metric Ton(MT)", value: "45MT" },
    { label: "Available In", value: "Warehouse" },
    { label: "Harvest Date", value: "15/04/2024" },
  ];

  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    api
      .get(`/farmer/lab_test/`)
      .then((result) => {
        setData(result.data);
        setLoading(false);
      })
      .catch((err) => {
        alert("Error: " + err.response.data.non_field_errors[0]);
        setLoading(false);
      });
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: "94vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontSize: "30px",
              fontWeight: 700,
              marginTop: "10px",
            }}
          >
            {t("Wheat")}
          </Typography>
          <div
            style={{
              height: "100%",
              maxHeight: "100%",
              overflowY: "auto",
            }}
          >
            {details.map(({ label, value }, index) => (
              <React.Fragment key={index}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <CustomLabel>
                      <Typography variant="body1" fontWeight="bold">
                        {label}:
                      </Typography>
                    </CustomLabel>
                  </Grid>
                  <Grid item xs={6}>
                    <CustomValue>
                      <Typography variant="body1">{value}</Typography>
                    </CustomValue>
                  </Grid>
                </Grid>
              </React.Fragment>
            ))}
            <Typography
              variant="body1"
              fontWeight="bold"
              style={{ margin: "20px 0" }}
            >
              {"Send an expression of interest"}
            </Typography>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Quantity"
                  type="number"
                  name="quantity"
                  placeholder="Enter Quantity"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  margin="normal"
                  fullWidth
                  type="date"
                  label={t("Date")}
                  name="sowing_date"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  margin="normal"
                  label="Location"
                  type="number"
                  name="location"
                  placeholder="Enter Location"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <CustomButton
                onClick={() => {
                  console.log("Submit Clicked");
                }}
              >
                {t("Confirm")}
              </CustomButton>
            </Grid>
          </div>
        </Container>
      </LoaderContainer>
    </>
  );
}
